/**
 * Cockpit route (Screen 1, FM-157) — eager stub. The interactive cockpit
 * component + its atoms are deferred to `new.lazy.tsx` so the simulator chunk
 * stays out of the bundle for non-admins.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flirtmachine/_authenticated/admin/simulator/new")({});
